import type { SiteCopy } from './types';

export const zh: SiteCopy = {
  loading: {
    kicker: '哒哒哒……',
    title: '马上就好！',
    description: '正在为你准备下一页。',
  },
  common: {
    available: '每周 20 小时',
    downloadCv: '下载简历',
    email: 'caishaojiang@gmail.com',
    github: 'https://github.com/agongdai',
    now: '至今',
    minutes: '{n} 分钟',
    wip: '开发中',
  },
  nav: {
    home: '首页',
    projects: '作品',
    articles: { storybook: '笔记', nebula: '文章', bento: '文章', studio: '文章' },
    showcases: { storybook: '游乐场', nebula: '实验室', bento: '实验室', studio: '作品展' },
    tools: '工具',
    cta: { storybook: '打个招呼', nebula: '聊一聊', bento: '雇我吧', studio: '开始合作' },
    menu: '主导航',
    openMenu: '打开菜单',
    closeMenu: '关闭菜单',
    whereTo: '去哪儿看看？',
    switchDesign: '切换设计',
    designHint: '同一个网站，换一种风格',
    designNudge: {
      storybook: '悄悄说：换个风格试试！',
      nebula: '新功能 · 一键切换整站设计',
      bento: '新功能 · 试试更大胆的风格',
      studio: '试试更柔和的风格',
    },
    dismiss: '关闭',
    toLight: '切换到浅色模式',
    toDark: '切换到深色模式',
    language: 'EN',
    otherLanguage: 'Switch to English',
    wallet: '钱包',
  },
  footer: {
    copyright: '© 2012 — 2026 蔡少将',
    place: {
      storybook: '在漳州用心绘制',
      nebula: '中国 · 漳州',
      bento: '中国 · 漳州',
      studio: '在漳州制作',
    },
    privacy: '隐私',
    terms: '条款',
    roadmap: '路线图',
    scrollTop: '回到顶部',
  },
  home: {
    skills: [
      { title: '产品前端', text: 'React、Next.js 和可扩展的设计系统。' },
      { title: '交易与 Web3', text: '交易所、托管、DEX 工具和钱包。' },
      { title: 'AI 原生交付', text: '用智能体交付小而经过测试的改动。' },
    ],
    clients: ['Binance', 'Bitfinex', 'CronosLabs', 'Pano AI', 'Toptal', 'EMBL-EBI', 'RingCentral'],
  },
  projects: {
    kicker: {
      storybook: '{n} 个小故事 ↓',
      nebula: '{n} 个项目 · {from} — {to}',
      bento: '作品 · {from} — {to}',
      studio: '{n} 个项目 · 始于 {from}',
    },
    title: {
      storybook: '我*做过*的东西',
      nebula: '我的*作品*',
      bento: '项目*。*',
      studio: '项目 *· {n}*',
    },
    lead: {
      storybook: '',
      nebula: '交易所、托管、AI 工具，以及我自己的产品。',
      bento: '',
      studio: '',
    },
    more: {
      storybook: '翻到下一页 · 还有 {n} 个',
      nebula: '再显示 {n} 个更早的项目',
      bento: '再显示 {n} 个更早的项目',
      studio: '再显示 {n} 个',
    },
    filterLabel: '筛选项目',
    filters: {
      all: '全部',
      own: { storybook: '我自己的', nebula: '我的产品', bento: '我的产品', studio: '我的产品' },
      trading: '交易与 DeFi',
      data: '数据与 AI',
      web: 'Web 平台',
    },
    view: '视图',
    grid: '网格',
    list: '列表',
    empty: '这里暂时还没有内容。',
  },
  project: {
    back: { storybook: '所有故事', nebula: '全部作品', bento: '全部作品', studio: '全部项目' },
    story: '第 {n} 个故事',
    visit: '访问网站',
    share: '分享',
    copied: '链接已复制',
    role: '角色',
    timeline: '时间',
    company: '公司',
    stack: '技术栈',
    part: '第 {n} 部分',
    features: '功能',
    whatIDid: '我做了什么',
    next: {
      storybook: '下一个故事 →',
      nebula: '下一个项目',
      bento: '下一个项目',
      studio: '下一个项目',
    },
    privateNote: '需要登录',
    wip: {
      title: {
        storybook: '还在*施工中*',
        nebula: '开发中',
        bento: '*开发中*',
        studio: '还在*工作室里打磨*',
      },
      note: '这个项目还在开发中，界面和功能都可能调整，下面有些内容只是早期预览。',
    },
    feature: '功能 {n}',
    stats: { features: '个功能', technologies: '项技术', months: '个月', years: '年' },
  },
  articles: {
    kicker: {
      storybook: '笔记',
      nebula: '文章 · 共 {n} 篇',
      bento: '文章 · {n} 篇',
      studio: '文章 · {n}',
    },
    title: {
      storybook: '来自*工作*的笔记',
      nebula: '实战*笔记*',
      bento: '笔记*。*',
      studio: '来自工作的笔记。*简短实用。*',
    },
    lead: { storybook: '简短、实用的技术文章，目前 {n} 篇。', nebula: '', bento: '', studio: '' },
    search: '搜索',
    searchPlaceholder: 'nginx、jest、next.js…',
    filterLabel: '按主题筛选',
    all: '全部',
    featured: '精选',
    empty: '没有匹配的文章。',
  },
  article: {
    back: { storybook: '笔记', nebula: '文章', bento: '文章', studio: '文章' },
    onThisPage: {
      storybook: '本篇目录',
      nebula: '本页目录',
      bento: '本页目录',
      studio: '本页目录',
    },
    ping: '有问题？找我聊！',
    previous: '← 上一篇',
    next: '下一篇 →',
    keepReading: '继续阅读',
    copyLink: '复制链接',
    demoRepo: '示例仓库',
  },
  showcases: {
    kicker: {
      storybook: '来玩玩 ↓',
      nebula: '实验室 · {n} 个作品',
      bento: '实验室 · {n} 个实验',
      studio: '作品展 · {n}',
    },
    title: {
      storybook: '前端*游乐场*',
      nebula: '可以*上手玩*的实验',
      bento: '实验室*。*',
      studio: '作品展 *· 用心做的小东西。*',
    },
    lead: {
      storybook: '{n} 个小实验，外加两个免费工具。',
      nebula: '精致的前端小作品，打开一个试试吧。',
      bento: '{n} 个前端实验，外加两个免费工具。打开一个试试吧。',
      studio: '',
    },
    tools: '工具',
    toolsNote: {
      storybook: '永久免费',
      nebula: '免费 · 在浏览器里运行',
      bento: '免费 · 在浏览器里运行',
      studio: '免费工具',
    },
    items: {
      panorama: { title: '全景图浏览', line: '拖动查看 360° 照片。' },
      'audio-player': { title: '音频播放器', line: '实时声音可视化。' },
      'fancy-border': { title: '炫彩边框', line: '旋转的锥形渐变边框。' },
      'flowing-dashed-lines': { title: '流动虚线', line: 'SVG 数据流动画。' },
      form: { title: '库存表单', line: 'RHF + Zod，条件字段。' },
      enterprise: { title: '企业落地页', line: '像素级还原的营销页面。' },
    },
  },
  tools: {
    kicker: { storybook: '免费小工具', nebula: '工具', bento: '工具', studio: '免费工具' },
    colorPicker: {
      title: '颜色*选择器*',
      line: 'HEX · RGB · HSL、色阶与对比度。',
      lead: '选一个颜色，以任意格式复制。',
    },
    svg2base64: {
      title: 'SVG → *Base64*',
      line: '粘贴 SVG，得到 data URI。',
      lead: '粘贴或拖入 SVG，复制为 data URI。',
    },
    hue: '色相',
    saturation: '饱和度',
    lightness: '亮度',
    hex: '输入颜色',
    shades: '色阶 · 点击选择',
    presets: { storybook: '颜料盒', nebula: '预设', bento: '色块调色板', studio: '工作室调色板' },
    contrast: '对比度 {n} : 1',
    copy: '复制',
    copied: '已复制',
  },
};
